import {
  MESApiService,
  TimeService,
  getMomentTz,
  spParameter,
} from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Moment } from "moment";
import { BilletHistory } from "../models/BilletsHistory";

const moment = getMomentTz();

type Props = {
  filterStartDate: Moment;
  filterEndDate: Moment;
  operatorId: number | null;
  heatId: number | null;
  operationTypeCode: string | null;
  locationId: number | null;
};

export const getBilletsHistory = async ({
  filterStartDate,
  filterEndDate,
  operatorId,
  heatId,
  operationTypeCode,
  locationId,
}: Props) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];

  const plantZone = TimeService.getInstance().getServerTimeZone();

  if (filterStartDate) {
    parameters.push({
      name: "StartDate",
      value: moment
        .tz(filterStartDate.format("YYYY-MM-DD"), plantZone)
        .toISOString(),
    });
  }
  if (filterEndDate) {
    parameters.push({
      name: "EndDate",
      value: moment
        .tz(filterEndDate.format("YYYY-MM-DD"), plantZone)
        .endOf("day")
        .toISOString(),
    });
  }
  if (operatorId) {
    parameters.push({ name: "OperatorId", value: operatorId });
  }
  if (heatId) {
    parameters.push({ name: "HeatId", value: heatId });
  }
  if (operationTypeCode) {
    parameters.push({ name: "OperationTypeCode", value: operationTypeCode });
  }
  if (locationId) {
    parameters.push({ name: "LocationId", value: locationId });
  }

  const resp = await apiService.callV2(
    "[BYI].[GetTransactionsHistoryIG]",
    parameters,
  );

  if (resp.ok) {
    let rows = get(resp, "data.tables[0].rows", []);

    rows = rows.map((bh: BilletHistory) => ({
      ...bh,
      Datetime: bh.Datetime ? moment.utc(bh.Datetime).toDate() : null,
    }));

    return {
      ok: true,
      data: rows as BilletHistory[],
    };
  } else {
    return {
      ok: false,
      message: resp.message,
    };
  }
};

export const getBYLocations = async () => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  return await apiService.callV2("[BYI].[GetLocationsDDP]", parameters);
};
